<template>
    <div style="height:100%">
    <el-menu :default-active="$route.path"
    style="height:100%"
             router
             unique-opened
             :collapse="iscollapse"
             :collapse-transition="false"
             background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b">
      <div v-for="(item,i) in lastMeun"
           :key="i">
        <el-submenu :index="item.prouter"
                    v-if="item.children">
          <template slot="title">
            <i :class="item.icon"></i>
            <span class="tohide">{{item.name}}</span>
          </template>
          <el-menu-item :index="val.crouter"
                        v-for="val in item.children"
                        :key="val.id">
            <i class="el-icon-s-help"></i>
            <span>{{val.name}}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item :index="item.prouter"
                      v-else>
          <i :class="item.icon"></i>
          <span slot="title">{{item.name}}</span>
        </el-menu-item>
      </div>
 
    </el-menu>
  </div>
  </template>
  <script>
    export default {
  data() {
    return {
      defaultActive: '/home',
      iscollapse: false,
      logourl: require('@/assets/logo.png'),
      username: null,
      show: false,
      lastMeun: [],
      pMeun: [],
      cMeun: [],
      meunList: [
        { id: '1', pid: '', name: '首页', router: '/home', icon: 'el-icon-eleme' },
        { id: '2', pid: '', name: '资产管理', router: '/mySalaryList', icon: 'el-icon-s-tools' },
        { id: '3', pid: '', name: '系统管理', router: '/system', icon: 'el-icon-star-on' },
        { id: '4', pid: '', name: '系统监控', router: '/proudct', icon: 'el-icon-edit' },
        { id: '5', pid: '3', name: '用户管理', router: '/system/user', icon: 'el-icon-edit' },
        { id: '6', pid: '3', name: '权限管理', router: '/system/user', icon: 'el-icon-edit' },
        { id: '7', pid: '4', name: '资源监控', router: '/system/user', icon: 'el-icon-edit' },
        { id: '8', pid: '4', name: '操作记录', router: '/system/user', icon: 'el-icon-edit' },
      ]
    }
  },
  mounted() {
    this.info()
  },
  methods: {
    info() {
      var pMeun = [] //父级菜单
      var cMeun = [] //子菜单
      if (this.meunList.length > 0) {
        //有数据则进行下一步
        //遍历菜单列表，如果没有pid(父级id，没有表示他是一级菜单)，则放进pMeun,有则放进cMeun
        this.meunList.forEach((item) => {
          if (!item.pid) {
            pMeun.push({
              id: item.id,
              name: item.name,
              icon: item.icon,
              prouter: item.router,
              // meta: { title: i.name, icon: i.icon, access: 1 },
              children: []
            })
          } else {
            cMeun.push(item)
          }
        })
        console.log(pMeun, cMeun)
        //判断pMeun和cMeun中id和pid是否相等，相等则将该项加入对应pMeun的children中
        pMeun.forEach((pitem) => {
          cMeun.forEach((citem) => {
            if (citem.pid == pitem.id) {
              // console.log(pitem, '11')
              pitem.children.push({
                id: citem.id,
                name: citem.name,
                crouter: citem.router
                //  meta: { title: i.name, icon: i.icon, access: 1 },
              })
            }
          })
        })
        //如果pMeun中的children没有数据的，则删除该children属性
        pMeun.forEach((item, index) => {
          if (!item.children.length) {
            delete pMeun[index].children
          }
        })
 
        console.log(pMeun, 'pMeun')
        this.lastMeun = pMeun //赋值给菜单数据源
      } else {
        retrun
      }
    },
    setcollapse() {
      this.iscollapse = !this.iscollapse
      this.$nextTick(() => {
        if (this.iscollapse) {
          $('#logo').css('width', '64px')
          $('.el-aside').css('width', 'auto')
          $('.tohide,.el-submenu__title .el-icon-arrow-right').css('display', 'none')
        } else {
          $('#logo').css('width', 'auto')
          $('.el-aside').css('width', '152px')
          $('.tohide,.el-submenu__title .el-icon-arrow-right').css('display', 'inline')
        }
      })
    }
  }
}
  </script>


// WEBPACK FOOTER //
// src/views/dashboard/components/Sliber.vue